// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__-b6ZE","swoosh":"SectionTitle_swoosh__vVcFU"};